var map = {
	"./mtn-mzansi-rhythm/background-image.png": 6546,
	"./mtn-unlock-more/background-image.png": 5147,
	"./mtn-unlock-yellow/background-image.png": 8562,
	"./mtn-yellow-rush/background-image.png": 5216,
	"./wp-gem-queens/background-image.png": 7606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5856;